<template>
	<div>
		<b-navbar type="dark" variant="dark">
			<b-navbar-brand to="/">
				<!--这里找图标较方便 http://www.51yuansu.com/search/juji-0-0-0-0-1/ -->
				<img width="32" height="32" src="~assets/img/logo.png" alt="Home">
			</b-navbar-brand>
			<b-navbar-nav>
				<slot></slot>
			</b-navbar-nav>
			<b-navbar-nav class="ml-auto">
				<slot name="right"></slot>
			</b-navbar-nav>
		</b-navbar>
		<router-view></router-view>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				
			}
		},
		computed: {
			isActive() {
				console.log(this.$route.path,this.path);
				return this.$route.path.indexOf(this.path) != -1
			},
			// activeStyle() {
			// 	return this.isActive ? {
			// 		color: this.activeColor
			// 	} : {}
			// }
		},
		methods: {
			getClasses: function() {
				// console.log(this.$route.path,this.$route.matched[0].path);
				return {
					active: this.isActive
				}
			}
		}
	}
</script>

<style>

</style>
